<template>
  <b-card no-body>
    <b-card-header class="pb-50">
      <h5> {{ $t('FIELD_SERVICES_FILTERS_TITLE') }} </h5>
    </b-card-header>
    <b-card-body>
      <b-row>
        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FIELD_SERVICES_CUSTOMERS_FILTER_LABEL') }}</label>
          <v-select 
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            :value="$store.getters['fieldServices.installation.list/customersFilter']"
            @input="value => {
                  $store.commit('fieldServices.installation.list/updateCustomersFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
            }"
            label="name" 
            :options="$store.getters['fieldServices.installation.list/customersOptions']" 
            class="w-100" 
            :reduce="val => val.id"
          />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FIELD_SERVICES_CONTRACTS_FILTER_LABEL') }}</label>
          <v-select 
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            :value="$store.getters['fieldServices.installation.list/contractsFilter']"
            @input="value => {
                  $store.commit('fieldServices.installation.list/updateContractsFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
            }"
            label="name" 
            :options="$store.getters['fieldServices.installation.list/contractsOptions']" 
            class="w-100" 
            :reduce="val => val.id"
          />
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FIELD_SERVICES_TECHNICIANS_FILTER_LABEL') }}</label>
          <v-select 
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            :value="$store.getters['fieldServices.installation.list/techniciansFilter']"
            @input="value => {
                  $store.commit('fieldServices.installation.list/updateTechniciansFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
            }"
            label="name" 
            :options="$store.getters['fieldServices.installation.list/techniciansOptions']" 
            class="w-100" 
            :reduce="val => val.id"
          />
        </b-col>

        <b-col lg="6" md="12" class="mb-md-0 mb-2">
          <label>{{ $t('FIELD_SERVICES_PRODUCTS_FILTER_LABEL') }}</label>
          <v-select 
            multiple 
            :close-on-select="false" 
            :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'" 
            :value="$store.getters['fieldServices.installation.list/productsFilter']"
            @input="value => {
                  $store.commit('fieldServices.installation.list/updateProductsFilter', { value })
                  $store.dispatch('fieldServices.installation.list/fetchList')
            }"
            :options="$store.getters['fieldServices.installation.list/productsOptions']" 
            class="w-100" 
          />
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>

import {
  BCard, 
  BCardHeader, 
  BCardBody, 
  BRow, 
  BCol, 
  BButton
} from 'bootstrap-vue'

import store from '@/store'

import vSelect from 'vue-select'

export default {
  components: {
    BRow, 
    BButton,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect
  },
  props: {},
  setup(props, { root }) {

    store.dispatch('fieldServices.installation.list/fetchFiltersOptions')

    return {}
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>
